export default "__VITE_ASSET__DLH0tK9t__"